<template>
	<div id="mobile-footer" class="hidden-sm-and-up" v-if="userIsAuthenticated">
		<button type="button" value="messages" :class="['mobile-nav__button', getClass('messages')]" @click="setActive('messages')"><i class="warning--text fas fa-comment"></i></button><button type="button" value="calendar" :class="['mobile-nav__button', getClass('calendar')]" @click="setActive('calendar')"><i class="success--text fas fa-calendar-alt"></i></button><button type="button" value="root" :class="['mobile-nav__button', getClass('dashboard')]" @click="setActive('dashboard')"><img v-show="active === 'dashboard'" src="/static/images/navbar/logo-color.svg" height="38" alt="" /><img v-show="active !== 'dashboard'" src="/static/images/navbar/logo-gray.png" height="38" alt="" /></button><button type="button" value="events" :class="['mobile-nav__button', getClass('events')]" @click="setActive('events')"><i class="info--text fas fa-search"></i></button><button type="button" value="saved" :class="['mobile-nav__button', getClass('saved')]" @click="setActive('saved')"><i class="error--text fas fa-heart"></i></button>
	</div>
	<!-- <v-bottom-nav
		v-if="userIsAuthenticated && showNav"
		class="hidden-sm-and-up"
		fixed
		shift
		:value="true"
		:active.sync="navActive"
		color="white"
	>
		<v-btn flat color="warning" value="messages">
			<span>Messages</span>
			<v-icon>fa-comment</v-icon>
		</v-btn>
		<v-btn flat color="success" value="calendar">
			<span>Calendar</span>
			<v-icon>fa-calendar-check-o</v-icon>
		</v-btn>
		<v-btn flat color="success" value="root">
			<span>Home</span>
			<img src="/static/images/navbar/logo-color.svg" height="24" alt="" />
		</v-btn>
		<v-btn flat color="info" value="events">
			<span>Events</span>
			<v-icon>fa-th-list</v-icon>
		</v-btn>
		<v-btn flat color="error" value="saved">
			<span>Saved</span>
			<v-icon>fa-heart</v-icon>
		</v-btn>
	</v-bottom-nav> -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'mobile-nav',
	data() {
		return {
			active: null,
			currentRoute: window.location.pathname
		}
	},
	mounted() {
		this.updateActive()
	},
	methods: {
		...mapActions(['setAuthModalOpen', 'setMobileNavActive', 'logout']),
		updateActive() {
			if (this.$route.name === 'dashboard' || this.$route.name === 'root') {
				this.active = 'dashboard'
			} else if (this.$route.name === 'events') {
				this.active = 'events'
			} else if (this.$route.name === 'calendar') {
				this.active = 'calendar'
			} else if (this.$route.name === 'saved') {
				this.active = 'saved'
			} else if (this.$route.name === 'messages') {
				this.active = 'messages'
			}
		},
		setActive(route) {
			// this.active = route
			this.$router.push({ name: route })
			this.updateActive()
		},
		getClass(route) {
			let c = ''
			if (route === this.active) {
				c = 'mobile-nav__active'
			} else {
				c = 'mobile-nav__inactive'
			}

			if (route === 'messages' && this.unreadNotifications) {
				c += ' mobile-badge'
			}
			return c
		},
		getDashboardImage(route) {
			if (route === this.active) {
				return '/static/images/navbar/logo-color.svg'
			}
			return '/static/images/navbar/logo-gray.png'
		}
	},
	watch: {
		$route(to, from) {
			this.updateActive()
		}
	},
	computed: {
		...mapGetters(['userIsAuthenticated', 'getMobileNavActive', 'user', 'getNotifications']),
		showNav() {
			if (
				this.currentRoute.indexOf('/host/add/') > -1 ||
				this.$route.name === 'event'
			) {
				return false
			}
			return true
		},
		unreadNotifications () {
			for (var i = 0; i < this.getNotifications.length; i++) {
				if (this.getNotifications[i]) {
					if (this.getNotifications[i].read === false) {
						return true
					}
				}
			}
		},
		navActive: {
			get() {
				return this.getMobileNavActive
			},
			set(val) {
				this.$router.push({ name: val })
				this.setMobileNavActive(val)
			}
		}
	}
}
</script>

<style lang="scss">
#mobile-footer {
	z-index: 200;
	margin-bottom: -1px;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	width: 100vw;
	height: 75px;
	background-color: #efefef;
	white-space: nowrap;

	.mobile-nav__button {
		height: 100%;
		display: inline;
		white-space: normal;
		margin: 0;
		padding: 0;
		font-size: 32px;
		text-align: center;
		vertical-align: middle;
		width: 20%;

		// -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
		// filter: grayscale(100%);
		img,
		i {
			margin-top: -4px;
			vertical-align: middle;
		}
	}
	.mobile-nav__inactive {
		i {
			color: #cccccc !important;
		}
	}
	.mobile-nav__active {
		-webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
		filter: grayscale(0%);
	}
	.mobile-nav__button:focus {
		outline: 0;
	}
	.mobile-badge:after{
		content: '';
		position: absolute;
		background: #de6455;
		height:1em;
		top:1.7em;
		left:2.7em;
		width:1em;
		line-height: 2em;
		font-size: 1rem;
		border-radius: 50%;
	}
}
</style>
